import { PageRouteBuilder } from "@common/route/page-route-builder";
import { CopyMeetingOrTemplatePageComponent as CopyMeetingOrTemplatePageComponent } from "./copy-meeting-or-template-page.component";

export const copyMeetingOrTemplatePageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-copy-meeting-or-template-page", CopyMeetingOrTemplatePageComponent)
    .requiresLogin()
    .atUrl("/tools/copy-meeting-or-template")
    .withTitle("Copy Meetings & Templates")
    .build();
